const initialState = {
  lifecycle: "booting",
  section: "hero",
  media: {
    source: null,
    currentTime: 0,
    duration: 31.765,
    loopIndex: 0,
    playing: false
  },
  performance: {
    tier: "medium",
    fps: 60,
    webglAvailable: true
  },
  pointer: {
    x: 0,
    y: 0,
    velocity: 0,
    material: "default"
  },
  audio: {
    enabled: false,
    unlocked: false,
    gain: 0
  },
  animal: {
    activeId: null,
    phase: "none",
    cueVisible: false
  },
  dialog: {
    projectId: null
  },
  portfolio: {
    filter: "all",
    activeProjectId: null,
    activeSkillId: null
  },
  interaction: {
    input: "unknown",
    sectionIndex: 0,
    sectionCount: 6,
    filtering: false
  }
};

function mergeState(current, patch) {
  const output = { ...current };
  for (const [key, value] of Object.entries(patch)) {
    output[key] =
      value &&
      typeof value === "object" &&
      !Array.isArray(value) &&
      current[key] &&
      typeof current[key] === "object"
        ? mergeState(current[key], value)
        : value;
  }
  return output;
}

export class ExperienceStore extends EventTarget {
  #state;

  constructor(seed = {}) {
    super();
    this.#state = mergeState(initialState, seed);
  }

  get() {
    return this.#state;
  }

  patch(patch, eventName = "state:change") {
    this.#state = mergeState(this.#state, patch);
    this.emit(eventName, this.#state);
    return this.#state;
  }

  emit(eventName, detail = {}) {
    this.dispatchEvent(new CustomEvent(eventName, { detail }));
  }

  on(eventName, handler, options) {
    this.addEventListener(eventName, handler, options);
    return () => this.removeEventListener(eventName, handler, options);
  }
}
